export default __webpack_public_path__ + "static/media/card1-1.3dba5fd0.jpg";